document.addEventListener('DOMContentLoaded', function () {
  // Quick "add to cart" AJAX for product cards / product form
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (res) { return res.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function (err) { console.error('Add to cart failed', err); });
    });
  });

  // ---------- Scroll reveal ----------
  // Elements fade and rise once as they enter the viewport. Cards inside a
  // group are staggered so a row arrives in sequence rather than all at once.
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reducedMotion || !('IntersectionObserver' in window)) return;

  var GROUPS = [
    { selector: '.section-heading', stagger: 0 },
    { selector: '.image-with-text__media', stagger: 0 },
    { selector: '.image-with-text__content', stagger: 90 },
    { selector: '.product-card', stagger: 70 },
    { selector: '.category-card', stagger: 90 },
    { selector: '.testimonial-card', stagger: 110 },
    { selector: '.rich-text__inner, .newsletter, .site-footer .footer-brand', stagger: 0 }
  ];

  GROUPS.forEach(function (group) {
    var nodes = document.querySelectorAll(group.selector);
    nodes.forEach(function (node, i) {
      node.classList.add('reveal');
      if (group.stagger) {
        // Restart the stagger every 4 items so long grids don't build a long delay
        node.style.setProperty('--reveal-delay', (i % 4) * group.stagger + 'ms');
      }
    });
  });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  document.querySelectorAll('.reveal').forEach(function (node) {
    observer.observe(node);
  });

  // Anything already in view on load reveals immediately, so the first
  // screenful is never left blank if the observer fires late.
  window.requestAnimationFrame(function () {
    document.querySelectorAll('.reveal').forEach(function (node) {
      var box = node.getBoundingClientRect();
      if (box.top < window.innerHeight && box.bottom > 0) {
        node.classList.add('is-visible');
      }
    });
  });
});
